import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthenticationService, MenuService, ThemeService, TranslationService } from '@assets/shared'
import { appSettings } from '../settings/app-settings';
import { DateTimeService } from 'eshava-controls';
import { mainNavigationRoutes } from './app-routing.module';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe } from '../../../eshava-ui-angular-assets-shared/src/lib/pipes/translate.pipe';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, TranslatePipe]
})
export class AppComponent implements OnDestroy {
  private _subscriptions: Subscription = new Subscription();

  public isInitialized = false;

  constructor(
    private _authenticationService: AuthenticationService,
    private _menuServe: MenuService,
    private _themeService: ThemeService,
    private _translationService: TranslationService,
    private _dateTimeService: DateTimeService
  ) {
    this._themeService.init();
    this._authenticationService.configure(appSettings.authentication.oidc);
    this.isInitialized = this._authenticationService.isInitialized();
    this._subscriptions.add(this._authenticationService.profileLoaded$.subscribe(profile => {
      this.isInitialized = true;
      const culture = (profile?.PreferredLanguage || '').split('-')[0] || 'de';

      if (!this._translationService.areTranslationsLoaded(culture)) {
        this._translationService.init(culture).then(_ => {
          this._menuServe.setNavigationItems(mainNavigationRoutes);
          this.initDateTimeService();
        });
      }
    }));
  }

  public ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  private initDateTimeService(): void {
    this._dateTimeService.monthTranslations.january = this._translationService.translate('January', 'calendar');
    this._dateTimeService.monthTranslations.february = this._translationService.translate('February', 'calendar');
    this._dateTimeService.monthTranslations.march = this._translationService.translate('March', 'calendar');
    this._dateTimeService.monthTranslations.april = this._translationService.translate('April', 'calendar');
    this._dateTimeService.monthTranslations.may = this._translationService.translate('May', 'calendar');
    this._dateTimeService.monthTranslations.june = this._translationService.translate('June', 'calendar');
    this._dateTimeService.monthTranslations.july = this._translationService.translate('July', 'calendar');
    this._dateTimeService.monthTranslations.august = this._translationService.translate('August', 'calendar');
    this._dateTimeService.monthTranslations.september = this._translationService.translate('September', 'calendar');
    this._dateTimeService.monthTranslations.october = this._translationService.translate('October', 'calendar');
    this._dateTimeService.monthTranslations.november = this._translationService.translate('November', 'calendar');
    this._dateTimeService.monthTranslations.december = this._translationService.translate('December', 'calendar');

    this._dateTimeService.weekdayTranslations.monday = this._translationService.translate('MondayShort', 'calendar');
    this._dateTimeService.weekdayTranslations.tuesday = this._translationService.translate('TuesdayShort', 'calendar');
    this._dateTimeService.weekdayTranslations.wednesday = this._translationService.translate('WednesdayShort', 'calendar');
    this._dateTimeService.weekdayTranslations.thursday = this._translationService.translate('ThursdayShort', 'calendar');
    this._dateTimeService.weekdayTranslations.friday = this._translationService.translate('FridayShort', 'calendar');
    this._dateTimeService.weekdayTranslations.saturday = this._translationService.translate('SaturdayShort', 'calendar');
    this._dateTimeService.weekdayTranslations.sunday = this._translationService.translate('SundayShort', 'calendar');
  }
}
